import React, { useMemo } from 'react';

import { useLocalSearchParams } from 'expo-router';
import { View } from 'react-native';

import { AppTakeoverMenuSectionTransition } from 'components/app-takeover/app-takeover-menu-section-transition';
import { useAppTakeoverMenuSection } from 'components/app-takeover/use-app-takeover';
import { FullWidthAutoHeightImage } from 'components/picture';
import { MenuNavigationTabs } from 'pages/menu/components/menu-navigation-tabs/menu-navigation-tabs';
import { MenuSection } from 'pages/menu/components/menu-section/menu-section';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

import { MenuHeaderNavigation } from '../components/menu-header-navigation';

// NEW one menu
export const MenuSectionPage = () => {
  const { mainMenu } = useUnifiedMenuContext();
  const { id } = useLocalSearchParams<{ id: string }>();

  const { title, options } = useMemo(() => {
    const section = mainMenu?.find(section => section.id === id);
    return { title: section?.name || '', options: section?.children || [] };
  }, [id, mainMenu]);

  const {
    headerBackgroundColor,
    itemBackgroundColor: takeoverBg,
    footerImage: takeoverFooterImage,
    footerImageOffset: takeoverFooterImageOffset,
  } = useAppTakeoverMenuSection(id);

  return (
    <View style={{ flex: 1, backgroundColor: takeoverBg }}>
      <AppTakeoverMenuSectionTransition sectionId={id} />
      {/* key is used to force re-render and display Section name after reloading page, 
          there is a memo messing up prop comparison */}
      <MenuHeaderNavigation
        title={title}
        key={title}
        headerBackgroundColorOverride={headerBackgroundColor}
      />
      <MenuNavigationTabs
        mainMenu={mainMenu}
        headerBackgroundColorOverride={headerBackgroundColor}
      />
      <MenuSection data={options} />
      {takeoverFooterImage && (
        <>
          {takeoverFooterImageOffset && (
            <View style={{ width: '100%', height: takeoverFooterImageOffset }}></View>
          )}
          <FullWidthAutoHeightImage
            source={takeoverFooterImage}
            style={{ position: 'absolute', bottom: 0 }}
          />
        </>
      )}
    </View>
  );
};
